import type { ColorShuffleInfo } from 'js/src/data/color-shuffle/color-shuffle-types';
import type { RootState } from 'js/src/libs/RootState';

const hasKey = (record: Readonly<Record<string, unknown>> | undefined, key: string) =>
    record !== undefined && Object.prototype.hasOwnProperty.call(record, key);

export function getSceneColorShuffleIndex(state: RootState, slide_id: string): number {
    const indexes = state.undoable?.present.color_shuffle.color_shuffle_index;
    return hasKey(indexes, slide_id) ? indexes[slide_id] : 0;
}

export function getSceneColorShuffleData(
    state: RootState,
    slide_id: string,
): ColorShuffleInfo | null {
    const data = state.undoable?.present.color_shuffle.color_shuffle_data;
    return hasKey(data, slide_id) ? data[slide_id] : null;
}

export function isSceneColorShuffleAvailable(state: RootState, slide_id: string): boolean {
    const colorShuffleData = getSceneColorShuffleData(state, slide_id);
    return (
        colorShuffleData !== null &&
        colorShuffleData.colorShuffles &&
        colorShuffleData.colorShuffles.length > 1
    );
}

export function getTemplateColorShufflePalettes(state: RootState): number[][] {
    return state.undoable?.present.color_shuffle.template_color_shuffle_palettes;
}

export function getTemplateColorShuffleIndex(state: RootState): number {
    return state.undoable?.present.color_shuffle.template_color_shuffle_index;
}
